"use client";

import { type QueryClient, useQuery } from "@tanstack/react-query";
import { useOspApiClientProvider } from "@hooks/useOspApiClientProvider";
import { fetchHasHoldings, resetHoldingsProbe } from "./probeHasHoldings";

export const HAS_HOLDINGS_QUERY_KEY = ["etf-overlap", "has-holdings"] as const;

/**
 * 当前用户是否有投资持仓。`staleTime: 0`：入口点击时要拿最新值（上传 / 连券商刚完成就能命中）。
 * 不新增 Valtio store（AGENTS.md Ask first）。
 */
export const useHasHoldings = (options?: { enabled?: boolean }) => {
  const { memberApi } = useOspApiClientProvider();
  return useQuery<boolean>({
    queryKey: HAS_HOLDINGS_QUERY_KEY,
    queryFn: () => fetchHasHoldings(memberApi),
    enabled: (options?.enabled ?? true) && Boolean(memberApi),
    staleTime: 0,
    retry: false,
  });
};

/** 上传成功 / Plaid 成功后调用：清登录场景缓存并让查询失效。 */
export const invalidateHasHoldings = (queryClient: QueryClient): void => {
  resetHoldingsProbe();
  void queryClient.invalidateQueries({ queryKey: HAS_HOLDINGS_QUERY_KEY });
};
